// extracted by mini-css-extract-plugin
export default {"root":"PlasmicPassword1_root__YeO6F","rootdanger":"PlasmicPassword1_rootdanger__Yc+nt"};